// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__EFHxb","projectImage":"Projects_projectImage__2aQCb","projectLogo":"Projects_projectLogo__jprs8"};